import React, {Suspense, useEffect, useState} from 'react';
import './App.css';
import {ThemeProvider as ThemeProviderMui} from "@mui/material";
import {customTheme} from "./config/theme/MuiTheme";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {useGitCheckLogVersion, useSetAgGrid} from "./config/globalConfig";
import './config/dictionary/i18n';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import GlobalContextProvider from "./util/state/GlobalContextProvider";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import dayjs from "dayjs";
import {useTranslation} from "react-i18next";
import {CookiesProvider} from 'react-cookie';
import CustomLoader from "./util/component/CustomLoader";
import ReactGA from 'react-ga4';
import {Box} from "@mui/system";
import RouteContainer from "./util/page/RouteContainer";
import { setCookie } from "./util/state/commonFunctions";

import ('dayjs/locale/en-gb.js');
import ('dayjs/locale/it.js');
import ('dayjs/locale/fr.js');

// @ts-ignore
ReactGA.initialize(window.appConfig.GOOGLE_ANALYTICS_ID);

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        }
    }
});

function App() {
    useGitCheckLogVersion();
    useSetAgGrid();
    const {i18n} = useTranslation();
    const [language, setLanguage] = useState('en');
    const validLanguages = ['en', 'it', 'fr'];

    const handleLoadLanguage = () => {
        const detectLanguage = () => {
            let language = i18n?.language ? i18n?.language?.toLowerCase() : 'en';
            if (language.includes('-')) {
                let array = language.split('-');
                if (array[0] === array[1]) {
                    return array[0];
                }
            }
            return language;
        }
        const language = detectLanguage();
        dayjs.locale(language);
        setCookie('lang_fe', language);
        return language;
    }

    useEffect(() => {
        setLanguage(handleLoadLanguage());
    }, [i18n.resolvedLanguage]);

    return (
        <Box>
            <React.StrictMode>
                <CookiesProvider>
                    <QueryClientProvider client={queryClient}>
                        <GlobalContextProvider>
                            <ThemeProviderMui theme={customTheme}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}
                                                      adapterLocale={validLanguages.includes(language) ? language : 'en'}>
                                    <BrowserRouter>
                                        <Suspense fallback={<CustomLoader loading={true}/>}>
                                            <RouteContainer/>
                                        </Suspense>
                                    </BrowserRouter>
                                </LocalizationProvider>
                            </ThemeProviderMui>
                        </GlobalContextProvider>
                        <ReactQueryDevtools initialIsOpen={false}/>
                    </QueryClientProvider>
                </CookiesProvider>
            </React.StrictMode>
        </Box>
    );
}

export default App;
